import React, { useCallback } from "react";
import { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Collapse } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { useTranslation } from "react-i18next";
import { useMaterialUIController } from "context";
import { call } from "services/axiosService/core";
import * as Sentry from "@sentry/browser";
import ReactPlayer from "react-player";
import MaxuLogo from "assets/images/nav-logo.png";
import MDBox from "components/MDBox";
import Loader from "pages/loader/Loader";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import IconButton from "@mui/material/IconButton";
import ArrowDropUpTwoToneIcon from "@mui/icons-material/ArrowDropUpTwoTone";
import ArrowDropDownTwoToneIcon from "@mui/icons-material/ArrowDropDownTwoTone";
import ContentPlayerDialog from "examples/Dialog/ContentPlayerDialog";

const MyGamePlan = () => {
  const [controller] = useMaterialUIController();
  const { profile, persona } = controller;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [gamePlan, setGamePlan] = useState([]);
  const [previousGamePlan, setPreviousGamePlan] = useState([]);
  const [previousYearsGamePlan, setPreviousYearsGamePlan] = useState([]);
  const [yearIndex, setYearIndex] = useState(0);
  const [userMetricsData, setUserMetricsData] = useState(null);
  const [likedContent, setLikedContent] = useState([]);
  const [dislikedContent, setDislikedContent] = useState([]);
  const [savedContent, setSavedContent] = useState([]);
  const [viewedContent, setViewedContent] = useState([]);
  const [recommendedContent, setRecommendedContent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noContent, setNoContent] = useState(false);
  const [content, setContent] = useState({});
  const [playContent, setPlayContent] = useState(false);
  const [hasCompletedAll, setHasCompletedAll] = useState(false);
  const [showCongratulations, setShowCongratulations] = useState(false);
  const [planType, setPlanType] = useState("myGamePlan");
  const [week, setWeek] = useState(0);

  const congratulationAnimation = {
    hidden: { opacity: 1, scale: 1, y: "-50vh" },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 3, // Now the duration will be respected
        ease: "easeInOut", // Smooth in & out effect
      },
    },
  };

  useEffect(() => {
    getUserGamePlan();
    loadUserContentMetrics();
  }, [profile]);

  const getUserGamePlan = () => {
    call(`users/${profile.id}/gameplan`, "GET", {})
      .then((response) => {
        if (response.status === 200) {
          console.log("response", response);
          const data = response.data.game_plan;
          const latest_plan = response.data.game_plan[0];
          const previous_plan = response.data.previous_game_plan || [];
          const previous_years_plan = response.data.previous_years_game_plan || [];
          setPreviousYearsGamePlan(previous_years_plan);
          setPreviousGamePlan(previous_plan);
          setGamePlan(response.data.game_plan);
          setHasCompletedAll(latest_plan.content.length == latest_plan.watched_content.length);
          setLoading(false);
        } else if (response.status === 404) {
          setGamePlan([]);
          setNoContent(true);
          setLoading(false);
        } else if (response.status === 440) {
          setLoading(false);
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        setLoading(false);
        console.log(error);
      });
  };

  const loadUserContentMetrics = () => {
    call(`users/${profile.id}/contentmetrics`, "GET", {})
      .then((res) => {
        if (res.status == 200) {
          let data = res.data;
          setUserMetricsData(data);
          setLikedContent([...data.likedcontent]);
          setDislikedContent([...data.dislikedcontent]);
          setViewedContent([...data.viewedcontent]);
          setSavedContent([...data.savedcontent]);
          setRecommendedContent([...data.recommendedcontent]);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const likeHandler = (title) => {
    let eventkey = { event: "likecontent", value: title };
    var currentlikedContent = [...likedContent];
    var currentdislikedContent = [...dislikedContent];
    currentlikedContent.push(title);
    // if content in disliked array remove it from there
    if (currentdislikedContent.includes(title)) {
      const index = currentdislikedContent.indexOf(title);
      currentdislikedContent.splice(index, 1);
      eventkey = { event: "likecontent-removedislike", value: title };
    }
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;

    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setLikedContent([...currentlikedContent]);
          setDislikedContent([...currentdislikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const dislikeHandler = (title) => {
    let eventkey = { event: "dislikecontent", value: title };
    var currentlikedContent = [...likedContent];
    var currentdislikedContent = [...dislikedContent];
    currentdislikedContent.push(title);
    // if content in liked array remove it from there
    if (currentlikedContent.includes(title)) {
      const index = currentlikedContent.indexOf(title);
      currentlikedContent.splice(index, 1);
      eventkey = { event: "dislikecontent-removelike", value: title };
    }
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setDislikedContent([...currentdislikedContent]);
          setLikedContent([...currentlikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const removeLikeHandler = (title) => {
    let eventkey = { event: "removelikecontent", value: title };

    var currentlikedContent = [...likedContent];
    const index = currentlikedContent.indexOf(title);
    currentlikedContent.splice(index, 1);
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setLikedContent([...currentlikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const removeDislikeHandler = (title) => {
    let eventkey = { event: "removedislikecontent", value: title };
    var currentdislikedContent = [...dislikedContent];
    const index = currentdislikedContent.indexOf(title);
    currentdislikedContent.splice(index, 1);
    let metricData = userMetricsData;
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setDislikedContent([...currentdislikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const saveHandler = (title) => {
    let eventkey = { event: "savedcontent", value: title };
    let currentSavedContent = [...savedContent];
    let metricData = userMetricsData;
    if (currentSavedContent.includes(title)) {
      const index = currentSavedContent.indexOf(title);
      currentSavedContent.splice(index, 1);
      eventkey = { event: "removeSaved", value: title };
    } else {
      currentSavedContent.push(title);
    }
    metricData["savedcontent"] = [...currentSavedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setSavedContent([...currentSavedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const getHeadingForWeek = (week, t) => {
    if (week < 5) {
      // Weeks 1–4 (weekly)
      return t("gamePlan.weekContent", { range: week });
    } else if (week < 7) {
      // Weeks 5–6, 7–8 (biweekly)
      const start = 5 + (week - 5) * 2;
      const end = start + 1;
      return t("gamePlan.weekContent", { range: `${start}-${end}` });
    } else {
      // From week 9 onward (every 4 weeks)
      const start = 9 + (week - 7) * 4;
      const end = start + 3;
      return t("gamePlan.weekContent", { range: `${start}-${end}` });
    }
  };

  const getContentLinkHandler = (item, type, weekIndex) => {
    call(`content/${item.title}`, "GET", {})
      .then((res) => {
        if (res.status == 200) {
          setWeek(weekIndex);
          setPlanType(type);
          setPlayContent(true);
          setContent(res.data);
        }
      })
      .catch((err) => {
        console.log("error is", err);
        Sentry.captureException(err);
      });
  };

  const closeContentPlayer = (congrats) => {
    setPlayContent(false);
    setShowCongratulations(congrats);
  };

  const goToPreviousYear = () => {
    setYearIndex(yearIndex + 1);
  };

  const goToNextYear = () => {
    setYearIndex(yearIndex - 1);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title={t("pageTitles.myGamePlan")} />

      {previousYearsGamePlan.length > 0 && (
        <MDBox px={5} py={2} display="flex" justifyContent="center" alignItems="center" gap={2}>
          <MDButton
            color="primary"
            disabled={yearIndex >= previousYearsGamePlan.length}
            onClick={goToPreviousYear}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mr: 2,
              textTransform: "none",
            }}
          >
            {t("buttonTitles.previousYearGamePlan")}
          </MDButton>

          <MDButton
            color="success"
            disabled={yearIndex === 0}
            onClick={goToNextYear}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              textTransform: "none",
            }}
          >
            {t("buttonTitles.nextYearGamePlan")}
          </MDButton>
        </MDBox>
      )}

      {yearIndex == 0 ? (
        <>
          <Grid container spacing={3}>
            {gamePlan?.length > 0 && (
              <GamePlanCard
                gamePlanType="myGamePlan"
                weekIndex={0}
                plan={gamePlan[0]}
                likedContent={likedContent}
                dislikedContent={dislikedContent}
                savedContent={savedContent}
                viewedContent={viewedContent}
                handlers={{
                  likeHandler,
                  dislikeHandler,
                  removeLikeHandler,
                  removeDislikeHandler,
                  saveHandler,
                  getContentLinkHandler,
                }}
                heading={getHeadingForWeek(gamePlan[0].week, t)}
                t={t}
              />
            )}
          </Grid>

          {showCongratulations && (
            <Grid item xs={12} sx={{ pb: 5, display: "flex", justifyContent: "center" }}>
              <motion.div initial="hidden" animate="visible" variants={congratulationAnimation}>
                <Card
                  sx={{
                    padding: 3,
                    textAlign: "center",
                    backgroundColor: "#E1F5FE",
                    borderRadius: "10px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <MDTypography variant="h5" fontWeight="bold" color="primary">
                    🎉 {t("gamePlan.congratulations")}! 🎉
                  </MDTypography>
                  <MDTypography variant="body1" color="textPrimary" mt={1}>
                    {t("gamePlan.completedAllContentMessage")}
                  </MDTypography>
                </Card>
              </motion.div>
            </Grid>
          )}

          {hasCompletedAll && (
            <Grid item xs={12}>
              <Card
                sx={{
                  padding: 3,
                  textAlign: "center",
                  backgroundColor: "#FAFAFA",
                  borderRadius: "10px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <MDTypography variant="h6" fontWeight="bold">
                  {t("gamePlan.lookingForMoreContent")}
                </MDTypography>
                <MDTypography variant="body2" color="textPrimary" mt={1}>
                  {t("gamePlan.askMaxwell")}
                </MDTypography>

                <MDButton
                  onClick={() => navigate("/dashboard", { state: { openBot: true } })}
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2, mx: 1 }}
                >
                  {t("gamePlan.chatWithMaxwell")}
                </MDButton>

                <MDButton
                  onClick={() => navigate("/contentlibrary")}
                  variant="outlined"
                  color="primary"
                  sx={{ mt: 2, mx: 1 }}
                >
                  {t("gamePlan.visitContentLibrary")}
                </MDButton>
              </Card>
            </Grid>
          )}

          <Grid container spacing={3}>
            {previousGamePlan?.length > 0 &&
              previousGamePlan.map((planItem, index) => (
                <GamePlanCard
                  key={index}
                  gamePlanType="previousGamePlan"
                  weekIndex={index}
                  plan={planItem}
                  likedContent={likedContent}
                  dislikedContent={dislikedContent}
                  savedContent={savedContent}
                  viewedContent={viewedContent}
                  handlers={{
                    likeHandler,
                    dislikeHandler,
                    removeLikeHandler,
                    removeDislikeHandler,
                    saveHandler,
                    getContentLinkHandler,
                  }}
                  heading={getHeadingForWeek(planItem.week, t)}
                  t={t}
                />
              ))}
          </Grid>
        </>
      ) : (
        <Grid container spacing={3}>
          {previousYearsGamePlan[yearIndex - 1].map((planItem, index) => (
            <GamePlanCard
              key={index}
              gamePlanType="previousYearsGamePlan"
              weekIndex={index}
              plan={planItem}
              likedContent={likedContent}
              dislikedContent={dislikedContent}
              savedContent={savedContent}
              viewedContent={viewedContent}
              handlers={{
                likeHandler,
                dislikeHandler,
                removeLikeHandler,
                removeDislikeHandler,
                saveHandler,
                getContentLinkHandler,
              }}
              heading={getHeadingForWeek(planItem.week, t)}
              t={t}
            />
          ))}
        </Grid>
      )}

      {playContent && (
        <ContentPlayerDialog
          playContent={playContent}
          gamePlan={gamePlan}
          setGamePlan={setGamePlan}
          previousGamePlan={previousGamePlan}
          setPreviousGamePlan={setPreviousGamePlan}
          previousYearsGamePlan={previousYearsGamePlan}
          setPreviousYearsGamePlan={setPreviousYearsGamePlan}
          closeContentPlayer={closeContentPlayer}
          content={content}
          userMetricsData={userMetricsData}
          setUserMetricData={setUserMetricsData}
          setViewedContent={setViewedContent}
          setHasCompletedAll={setHasCompletedAll}
          userId={profile.id}
          week={week}
          planType={planType}
          yearIndex={yearIndex}
          t={t}
        />
      )}

      {noContent && (
        <MDBox mt={5}>
          <Card style={{ backgroundColor: "#10b0d5", padding: 20, opacity: 0.8 }}>
            <MDBox display="flex" flexDirection="column">
              <MDTypography
                textAlign="center"
                justifyContent="center"
                component="h3"
                fontWeight="medium"
                color="white"
                flexWrap="wrap"
              >
                {t("playList.noContentAvailable")}
              </MDTypography>
              <MDTypography
                textAlign="center"
                component="h3"
                variant="body2"
                fontWeight="medium"
                color="white"
                alignItems="center"
                flexWrap="wrap"
              >
                {t("playList.contactSupport")} {"  "}
                <a href="mailto:support@maxu.co"> support@maxu.co </a>
              </MDTypography>
            </MDBox>
          </Card>
        </MDBox>
      )}

      {loading && (
        <Dialog open={loading} fullScreen>
          <DialogContent>
            <Loader loaderText={t("loaderText.loadingGamePlan")} />
          </DialogContent>
        </Dialog>
      )}
    </DashboardLayout>
  );
};

export default MyGamePlan;

const GamePlanCard = ({
  gamePlanType,
  weekIndex,
  plan,
  likedContent,
  dislikedContent,
  savedContent,
  viewedContent,
  handlers,
  heading,
  t,
}) => {
  const totalItems = plan.content.length;
  const viewedItems = plan.watched_content.length;
  const progressPercentage = totalItems > 0 ? Math.round((viewedItems / totalItems) * 100) : 0;
  const [collapsed, setCollapsed] = useState(progressPercentage >= 100);
  if (!Array.isArray(plan.content)) return null;
  const {
    likeHandler,
    dislikeHandler,
    removeLikeHandler,
    removeDislikeHandler,
    saveHandler,
    getContentLinkHandler,
  } = handlers;

  return (
    <Grid item xs={12} sx={{ marginBottom: 5 }}>
      <Card
        sx={{
          paddingTop: 3,
          paddingX: 2,
          marginTop: 2,
          height: "100%",
          backgroundColor: "#FAFAFA",
          borderRadius: 10,
          boxShadow: "2px 2px 9px #10b0d5",
          border: "2px solid #10b0d5",
        }}
      >
        <MDBox
          pb={2}
          px={2}
          lineHeight={1.25}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          onClick={() => setCollapsed(!collapsed)}
        >
          <MDTypography
            variant="h4"
            fontWeight="bold"
            color="#333"
            sx={{
              flexGrow: 1,
              textAlign: "center",
            }}
          >
            {heading}
          </MDTypography>

          <IconButton
            onKeyDown={(e) => {
              if (e.key === "ArrowDown" && collapsed) {
                setCollapsed(false);
              }
              if (e.key === "ArrowUp" && !collapsed) {
                setCollapsed(true);
              }
            }}
            aria-expanded={!collapsed}
            aria-label={collapsed ? "Expand game plan content" : "Collapse game plan content"}
            sx={{
              backgroundColor: "#10b0d5",
              color: "#fff",
              borderRadius: 1,
              width: 40,
              height: 40,
              padding: 0,
              "&:hover": {
                backgroundColor: "#238fa8", // darker blue on hover
              },
            }}
          >
            {collapsed ? (
              <ArrowDropDownTwoToneIcon fontSize="large" />
            ) : (
              <ArrowDropUpTwoToneIcon fontSize="large" />
            )}
          </IconButton>
        </MDBox>

        <Collapse in={!collapsed} timeout="auto" unmountOnExit>
          <>
            {/* Content Items */}
            <Grid container spacing={3} className="mt-3" paddingX={2}>
              {plan.content.map((item, index) => {
                let icon = "movie";
                const type = item.content_type.toLowerCase();

                if (type === "infographic") icon = "leaderboard";
                else if (type === "article") icon = "article";
                else if (type === "worksheet") icon = "note";

                return (
                  <Grid item xs={12} md={4} key={item.id || index}>
                    <DefaultProjectCard
                      item={item}
                      icon={icon}
                      type={item.content_type}
                      title={item.title}
                      content_url={item.content_url}
                      image={item.thumbnail_url || MaxuLogo}
                      getContentLinkHandler={getContentLinkHandler}
                      shareable={false}
                      liked={likedContent.includes(item.title)}
                      disliked={dislikedContent.includes(item.title)}
                      saved={savedContent.includes(item.title)}
                      viewed={viewedContent.includes(item.title)}
                      likeHandler={likeHandler}
                      dislikeHandler={dislikeHandler}
                      removeLikeHandler={removeLikeHandler}
                      removeDislikeHandler={removeDislikeHandler}
                      saveHandler={saveHandler}
                      action={{
                        type: "external",
                        route: item.content_url,
                        color: "info",
                        label: t("buttonTitles.view"),
                      }}
                      gamePlanType={gamePlanType}
                      weekIndex={weekIndex}
                    />
                  </Grid>
                );
              })}
            </Grid>

            {/* Progress Blocks */}
            <Box display="flex" alignItems="center" gap={2} mt={4}>
              <Box display="flex" gap={1} flexGrow={1}>
                {plan.content.map((_, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: "20px",
                      height: "20px",
                      borderRadius: "4px",
                      backgroundColor: index < plan.watched_content.length ? "#6DA34D" : "#c8e9f7",
                      flexGrow: 1,
                    }}
                  />
                ))}
              </Box>
            </Box>

            {/* Progress Text */}
            <Typography
              variant="body2"
              textAlign="center"
              sx={{ minWidth: "40px", fontWeight: "bold", mt: 2 }}
            >
              {progressPercentage}%
            </Typography>
          </>
        </Collapse>
      </Card>
    </Grid>
  );
};
